import * as React from 'react';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/styles';
import { withBaseProps } from '../Utils';
import { border, toCssValue } from '@topconagriculture/theme';
import { FontIcon } from '../FontIcon';
const styles = (theme) => createStyles({
    sectionHeader: {
        width: '100%',
        padding: toCssValue([0, theme.space.padding.small]),
        marginBottom: theme.space.margin.default,
        borderBottom: border(theme.color.grey.light, 1, 'dashed'),
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontSize: 24,
        color: theme.color.font.dark,
    },
    sectionIcon: {
        fontSize: 24,
        color: theme.color.font.dark,
        marginRight: theme.space.margin.small,
    },
});
const SectionTitle = (props) => {
    const { classes, className: classNameProp, title, iconName, testId = 'SectionTitle' } = props;
    return (React.createElement("div", { className: classNameProp, "data-testid": `${testId}` },
        React.createElement("div", { className: classes.sectionHeader },
            iconName && React.createElement(FontIcon, { top: 2, className: classes.sectionIcon, iconName: iconName }),
            title)));
};
const ComposedSectionTitle = compose(withBaseProps({ styles }))(SectionTitle);
ComposedSectionTitle.displayName = 'SectionTitle';
export default ComposedSectionTitle;
//# sourceMappingURL=SectionTitle.js.map